import { render, staticRenderFns } from "./DynamicViewTransaction.vue?vue&type=template&id=2bb3a326"
import script from "./DynamicViewTransaction.vue?vue&type=script&lang=js"
export * from "./DynamicViewTransaction.vue?vue&type=script&lang=js"
import style0 from "./DynamicViewTransaction.vue?vue&type=style&index=0&id=2bb3a326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports